import React from "react";
import { BOMDashboardContextProvider } from "./BOMDashboard.context";
import BOMMain from "./Main";

export function BOMTab() {
  return (
    <BOMDashboardContextProvider tabType="bom">
      <BOMMain />
    </BOMDashboardContextProvider>
  );
}

export function PNIDTab() {
  return (
    <BOMDashboardContextProvider tabType="pnid">
      <BOMMain />
    </BOMDashboardContextProvider>
  );
}
